export default __webpack_public_path__ + "static/media/dark_beginner.e687cb20.svg";